export const closeButton = "qhlP_d";
export default {closeButton};